import { IWorkSpaceRepository } from "@/core/repositories/workspace";

export class GetWorkspaceUserRoles {
  constructor(private readonly workspaceRepository: IWorkSpaceRepository) {}

  async execute(): Promise<{
    roles: string[];
    roleNames: string[];
  }> {
    const workSpaceUserRoles = await this.workspaceRepository.getWorkspaceUserRoles();
    return {
      roles: workSpaceUserRoles?.roles ?? [],
      roleNames: workSpaceUserRoles?.roleNames ?? [],
    };
  }
}
